import { render, staticRenderFns } from "./addCollectionRecordDialog.vue?vue&type=template&id=5f356210"
import script from "./addCollectionRecordDialog.vue?vue&type=script&lang=js"
export * from "./addCollectionRecordDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports